import type { DebtTransactionType } from '@/lib/api/customer-debt-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

type BadgeVariant =
    'default' | 'secondary' | 'destructive' | 'success' | 'warning'

const CONFIG: Record<
    DebtTransactionType,
    { variant: BadgeVariant; getLabel: () => string }
> = {
    sale: {
        variant: 'destructive',
        getLabel: () => m.customer_debt_type_sale(),
    },
    payment: {
        variant: 'success',
        getLabel: () => m.customer_debt_type_payment(),
    },
    adjustment: {
        variant: 'warning',
        getLabel: () => m.customer_debt_type_adjustment(),
    },
    return: {
        variant: 'secondary',
        getLabel: () => m.customer_debt_type_return(),
    },
    opening: {
        variant: 'secondary',
        getLabel: () => m.customer_debt_type_opening(),
    },
    refund: {
        variant: 'warning',
        getLabel: () => m.customer_debt_type_refund(),
    },
    return_fee: {
        variant: 'warning',
        getLabel: () => m.customer_debt_type_return_fee(),
    },
}

export function DebtTypeBadge({ type }: { type: DebtTransactionType }) {
    const cfg = CONFIG[type] ?? CONFIG.adjustment
    return <Badge variant={cfg.variant}>{cfg.getLabel()}</Badge>
}
